import { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getSupportTickets, type SupportTicket } from '../../api';
import { getApiErrorMessage } from '../../utils/apiError';
import SupportTicketList from './SupportTicketList';
import './SupportPage.css';

const SupportPage = () => {
  const location = useLocation();
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setTickets(await getSupportTickets());
    } catch (err) {
      setError(getApiErrorMessage(err, 'Не удалось загрузить обращения'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="support-page">
      <div className="support-container">
        <header className="support-header">
          <img src="/support.png" alt="" className="support-header-icon" />
          <h2>Поддержка</h2>
          <p>
            Опишите, что не получается или работает не так. Ответ придёт сюда же,
            а значок «Поддержка» в меню подскажет, что он появился.
          </p>
        </header>

        <Link to="/support/new" state={location.state} className="support-cta">
          Новое обращение
        </Link>

        {loading ? (
          <div className="support-state" role="status">
            Загрузка…
          </div>
        ) : error ? (
          <div className="support-state support-state--error" role="alert">
            {error}{' '}
            <button type="button" className="support-btn" onClick={() => void load()}>
              Повторить
            </button>
          </div>
        ) : tickets.length === 0 ? (
          <div className="support-state ui-panel ui-panel-tight">
            Обращений пока нет
          </div>
        ) : (
          <SupportTicketList tickets={tickets} />
        )}
      </div>
    </div>
  );
};

export default SupportPage;
